import { http } from "../http";

export const getShoppingCart = async () => {
  try {
    const response = await http.get(`/cart/get_cart_items`);
    const { data } = response;
    if (data) {
      return data.data;
    }
    return [];
  } catch (ex) {
    console.log(ex);
  }
};

export const emptyCart = async () => {
  try {
    const response = await http.get(`/cart/quick_empty_cart`);
    return response.data;
  } catch (ex) {
    console.log(ex);
  }
};
